import React from "react";
import {useHistory} from "react-router-dom";

function Footer(props) {
    const history = useHistory();
    return (
        <div>
            {/* <div className="FooterButtons"> */}
            <div className="FooterButton">
                {props.footerButton.map((btnNames) => (
                    <button onClick={() => history.push(`/${btnNames.link}`)}>
                        {btnNames.name}
                    </button>
                ))}
            </div>
            {/* </div> */}
            <div className="FooterOptions">
                {props.categoryList.map((arrayOptions) => (
                    <>
                        <div className="Block">
                            <div className="BlockCategory">
                                <p>+ {arrayOptions.category}</p>
                            </div>
                            <ul className="BlockBrandNames">
                                {arrayOptions.brandNames.map((brandName) => (
                                    <li>{brandName}</li>
                                ))}
                            </ul>
                        </div>
                    </>
                ))}
            </div>
        </div>
    );
}

export default Footer;
